import React from 'react';

import { traceEvent } from '@wk/wk-gatherer';

import CloseIcon from './CloseIcon';
import OpenIcon from './OpenIcon';

interface QaItemCardProps {
  question: string;
  answer: string;
  onClick: () => void;
  open: boolean;
  needTrace?: boolean;
}

const QaItemCard: React.FC<QaItemCardProps> = ({ question, answer, onClick, open, needTrace = true }) => {
  const handleClick = () => {
    onClick();
    if (needTrace && !open) {
      // 只有将未展开的卡片展开时才埋点，搜索详情页不需要埋点
      traceEvent({
        data: {
          _event: 'C_Faq_Question',
          cardName: question,
        },
      });
    }
  };
  return (
    <div className="space-y-2 rounded-xl bg-wk-bg-2 px-4 py-[14px] xl:space-y-3 xl:px-6 xl:py-5">
      <div className="flex cursor-pointer items-center justify-between" onClick={handleClick}>
        <h3 className="font-semibold xl:text-[20px]" dangerouslySetInnerHTML={{ __html: question }} />
        <span className={`ml-5 transform transition-transform xl:ml-10 ${open ? 'rotate-180' : ''}`}>
          {open ? <CloseIcon /> : <OpenIcon />}
        </span>
      </div>
      {open && (
        <div
          className="xl:texg-[16px] text-[14px] text-wk-words-3 [&_a]:text-wk-blue-400  [&_a]:underline"
          dangerouslySetInnerHTML={{ __html: answer }}
        />
      )}
    </div>
  );
};

export default QaItemCard;
